import { useEffect, useState } from "react";

import { Text } from "../../../Components/Text";
import { ContainerFlex } from "../../../Components/Layout";

const Ads = ({ list }) => {
  const [listSourcesByDate, setListSourcesByDate] = useState([]);

  useEffect(() => {
    if (list && Object.keys(list).length > 0) {
      const anuncios = Object.entries(list)
        .map(([anuncio, { count, sum }]) => ({ anuncio, count, sum }))
        .sort((a, b) => b.count - a.count);

      setListSourcesByDate(anuncios);
    } else {
      setListSourcesByDate([]);
    }
  }, [list]);

  return (
    <ContainerFlex padding="3" bgColor="white" className="shadow-sm">
      <Text tag="h5">Anúncios</Text>
      <hr />
      <ContainerFlex style={{ maxHeight: "300px", scrollbarWidth: "thin" }} className="overflow-auto">
        {listSourcesByDate.length > 0 ? (
          listSourcesByDate.map(({ anuncio, count }) => (
            <ContainerFlex
              key={anuncio}
              padding="1"
              marginBottom="1"
              border
              rounded
              between
            >
              <Text tag="small">{anuncio}</Text>
              <Text fontWeight="bold">{count}</Text>
            </ContainerFlex>
          ))
        ) : (
          <Text>Nenhum anúncio encontrado</Text>
        )}
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default Ads;
